import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AuthenticationService } from '../../../helpers/auth.services';
import { ProfileService } from './../../../pages/profile/profile-service';
import PRNService from 'src/app/services/PrnService';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserMenuComponent implements OnInit, OnDestroy {
  public userImage: SafeUrl | string = "assets/img/users/user.jpg"; // CHANGED type, kept fallback
  private currentUserSubject: BehaviorSubject<any>;
  userId: any;
  userDetails: any = {};
  role: any;
  isDisabled: boolean = true;
  private currentObjectUrl: string | null = null; // NEW
  private sub: Subscription; // NEW

  constructor(
    private router: Router,
    private profileService: ProfileService,
    private prnService: PRNService, // NEW
    private sanitizer: DomSanitizer, // NEW
    private authenticationService: AuthenticationService
  ) {
    if (sessionStorage.getItem('currentUser') != "") {
      var currentUser = JSON.parse(sessionStorage.getItem('currentUser') || '{}');
      this.userId = currentUser && currentUser.id;
      this.role = currentUser.roles;
      if (this.role == "ROLE_ADMIN") {
        this.isDisabled = false;
      }
    }
  }

  ngOnInit() {
    if (this.userId) {
      this.getuserDetails();
      this.loadProfilePhoto(); // NEW
    }
    // NEW: refresh the header avatar the instant a new photo is uploaded
    // on the Edit Profile page, without needing to reload
    this.sub = this.profileService.userUpdated$.subscribe(() => {
      this.loadProfilePhoto();
    });
  }

  ngOnDestroy() { // NEW
    this.sub?.unsubscribe();
    if (this.currentObjectUrl) {
      URL.revokeObjectURL(this.currentObjectUrl);
    }
  }

  getuserDetails() {
    this.profileService.getUseretails(this.userId).subscribe(res => {
      this.userDetails = res;
    });
  }

  // NEW: same pattern as profile.component.ts
  loadProfilePhoto(): void {
    this.prnService.fetchDocumentsByModule('USER_PROFILE', this.userId).subscribe({
      next: (res: any[]) => {
        if (res && res.length > 0) {
          const latest = res[res.length - 1];
          this.prnService.downloadPreviewFromS3(latest.filePath).subscribe({
            next: (blob: Blob) => {
              if (this.currentObjectUrl) {
                URL.revokeObjectURL(this.currentObjectUrl);
              }
              this.currentObjectUrl = URL.createObjectURL(blob);
              this.userImage = this.sanitizer.bypassSecurityTrustUrl(this.currentObjectUrl);
            },
            error: () => { this.userImage = "assets/img/users/user.jpg"; }
          });
        } else {
          this.userImage = "assets/img/users/user.jpg";
        }
      },
      error: () => { this.userImage = "assets/img/users/user.jpg"; }
    });
  }

  removeUser() {
    window.sessionStorage.removeItem('currentUser');
    window.localStorage.clear();
    this.router.navigate(['/login']);
    this.authenticationService.logout();
  }
}